import React, { Component } from 'react';
//import Snackbar from '@material-ui/core/Snackbar'
//import IconButon from '@material-ui/core/IconButton'
// import ReCAPTCHA from "react-google-recaptcha";


class Devis extends Component {
    constructor() {
        super();
        this.state = {
            nom: "",
            prenom: "",
            numero: "",
            adresse: "",
            code_postal: "",
            ville: "",
            telephone: "",
            email: "",
            numero1: "",
            adresse1: "",
            code_postal1: "",
            ville1: "",
            numero_parcelle: "",
            projet_immobilier: "",
            description: "",
            // message: "",
            isLoading: false,
            asLoading: false
        }
        this.handlerChange = this.handlerChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }
    handlerChange(event) {
        console.log(event.target.name);
        switch (event.target.name) {
            case 'Nom':
                console.log('Je suis dans la condition name')
                this.setState({ nom: event.target.value });
                break;
            case 'Prenom':
                this.setState({ prenom: event.target.value });
                break;
            case 'Numero':
                this.setState({ numero: event.target.value });
                break;
            case 'Adresse':
                this.setState({ adresse: event.target.value });
                break;
            case 'Code_postal':
                this.setState({ code_postal: event.target.value });
                break;
            case 'Ville':
                this.setState({ ville: event.target.value });
                break;
            case 'telephone':
                this.setState({ telephone: event.target.value });
                break;
            case 'email':
                this.setState({ email: event.target.value });
                break;
            case 'Numero1':
                this.setState({ numero1: event.target.value });
                break;
            case 'Adresse1':
                this.setState({ adresse1: event.target.value });
                break;
            case 'Code_postal1':
                this.setState({ code_postal1: event.target.value });
                break;
            case 'Ville1':
                this.setState({ ville1: event.target.value });
                break;
            case 'Numero_parcelle':
                this.setState({ numero_parcelle: event.target.value });
                break;
            case 'Projet_immobilier':
                this.setState({ projet_immobilier: event.target.value });
                break;
            case 'description':
                this.setState({ description: event.target.value });
                break;
            default:
                break;
        }
    }
    snackbarClose = (event) => {
        this.setState({ snackbaropen: false })
    }
    handleSubmit(event) {
        event.preventDefault();
        this.setState({ isLoading: true })
        console.log(this.state)
        fetch("http://localhost:3000/devis",
            {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(this.state),
            })
            .then(res => res.json())
            .then(
                res => this.setState({ snackbarmessage: res.message }),
            )
            .then(
                () => this.setState({ isLoading: false })
            )
            .then(
                () => this.setState({ asLoading: true })
            )
    }
    render() {
        return (
            <div>
                <div className="formulaire">
                    <form className="container" onSubmit={this.handleSubmit}>
                        {/* civilite du client */}
                        <div className="max-wi">
                            <div className="input-group-text"><strong>Civilité client</strong></div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Nom</div>
                                    </div>
                                    <input type="text" name="Nom" placeholder="Nom" className="form-control" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Prenom</div>
                                    </div>
                                    <input type="text" name="Prenom" placeholder="Prenom" className="form-control" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Numero</div>
                                    </div>
                                    <input type="number" name="Numero" placeholder="Numero" className="form-control" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Adresse</div>
                                    </div>
                                    <input type="text" name="Adresse" placeholder="Adresse" className="form-control" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Code postal</div>
                                    </div>
                                    <input type="text" name="Code_postal" className="form-control" placeholder="code postal" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Ville</div>
                                    </div>
                                    <input type="text" name="Ville" placeholder="Ville" className="form-control" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Telephone</div>
                                    </div>
                                    <input type="text" name="telephone" className="form-control" placeholder="numéro de téléphone" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Email</div>
                                    </div>
                                    <input type="email" name="email" className="form-control" placeholder="exemple@email.fr" onChange={this.handlerChange} />
                                </div>
                            </div>
                            {/* adresse du projet  */}
                            <div className="input-group-text"><strong>Adresse du projet</strong></div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Numero</div>
                                    </div>
                                    <input type="number" name="Numero1" placeholder="Numero" className="form-control" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Adresse</div>
                                    </div>
                                    <input type="text" name="Adresse1" placeholder="Adresse" className="form-control" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Code postal</div>
                                    </div>
                                    <input type="text" name="Code_postal1" className="form-control" placeholder="code postal" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Ville</div>
                                    </div>
                                    <input type="text" name="Ville1" placeholder="Ville" className="form-control" onChange={this.handlerChange} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Numero de la parcelle</div>
                                    </div>
                                    <input type="text" name="Numero_parcelle" placeholder="Numero de la parcelle" className="form-control" onChange={this.handlerChange} />
                                </div>
                            </div>


                            <div className="form-group">
                                <div className="input-group-text">Description de votre projet</div>
                                <textarea name="Description" className="form-control" id="exampleFormControlTextarea1" placeholder="Description de votre projet" rows="3" onChange={this.handlerChange}></textarea>
                            </div>
                            <div className="g-recaptcha" data-sitekey="6LeY6s4UAAAAAHyzz7lHYZy5L85nAQWj_2doiJ9M"></div>
                            {this.state.isLoading ?
                                <div className="d-block text-center pb-4" disabled>
                                    <button className="btn btn-primary" type="submit">Envoie en cours...</button>
                                </div> :
                                <div className="d-block text-center pb-4">
                                    <button className="btn-envoyer btn btn-primary" type="submit">Envoyer</button>
                                </div>
                            }
                            {this.state.asLoading ?
                                <div className="alert alert-success" role="alert">
                                    {this.state.snackbarmessage}
                                </div>
                                :
                                ""
                            }
                        </div>
                    </form>
                </div>
            </div >
        )
    }
}

export default Devis;